import store from "../store/index";
import ApiHelpers from "../helpers/ApiHelpers";

export const tenantBillingService = {
    fetchInvoices,
    downloadInvoice,
    fetchInvoiceAttachments,
    downloadAttachment,
    getTenantBillingReminderMessage
};

async function fetchInvoices() {
    const response = await ApiHelpers.makeAPICall(
        `${store.state.appState.apiURL}/tenant/invoices`,
        "GET",
        null,
        false
    );

    return await handleResponse(response);
}

async function downloadInvoice({ invoiceId }) {
    const response = await ApiHelpers.makeAPICall(
        `${store.state.appState.apiURL}/tenant/invoices/${invoiceId}/download`,
        "GET",
        null,
        false
    );

    await handleExportErrorResponse(response);

    const blob = await response.blob();
    const contentDisposition = response.headers.get("content-disposition");
    let fileName = `Invoice_${invoiceId}.pdf`;
    fileName = extractFileName(contentDisposition, fileName);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

async function fetchInvoiceAttachments({ invoiceId }) {
    const response = await ApiHelpers.makeAPICall(
        `${store.state.appState.apiURL}/tenant/invoices/${invoiceId}/attachments`,
        "GET",
        null,
        false
    );
    return await handleResponse(response);
}

async function downloadAttachment({ attachmentId }) {
    const response = await ApiHelpers.makeAPICall(
        `${store.state.appState.apiURL}/attachments/${attachmentId}/download`,
        "GET",
        null,
        false,
        { responseType: 'blob' }
    );

    await handleExportErrorResponse(response);

    const blob = await response.blob();
    const contentDisposition = response.headers.get("content-disposition");
    let fileName = `Attachment_${attachmentId}`;
    fileName = extractFileName(contentDisposition, fileName);

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

async function getTenantBillingReminderMessage() {
    const response = await ApiHelpers.makeAPICall(
        `${store.state.appState.apiURL}/tenant/billing-reminder`,
        "GET",
        null,
        false
    );
    return await handleResponse(response);
}

export function extractFileName(contentDisposition, fallback = "download.pdf") {
  if (!contentDisposition) return fallback;

  const utf8 = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8?.[1]) return decodeURIComponent(utf8[1]);

  const ascii = contentDisposition.match(/filename="([^"]+)"/i);
  if (ascii?.[1]) return ascii[1];

  return fallback;
}

async function handleExportErrorResponse(response) {
    if (!response.ok) {
      let message = `Export failed with status ${response.status}`;
  
      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const errorBody = await response.json();
        if (errorBody?.error?.message) {
          message = errorBody.error.message;
        }
      }
  
      return Promise.reject({ status: response.status, ok: false, message });
    }
  
    return response; 
}

async function handleResponse(response) {
    try {
        const body = await response.json();
        if (body?.status?.toLowerCase() === 'success') {
            return body.payload;
        } else {
            return Promise.reject(body.error || { message: 'Some error occured. ' });
        }
    } catch (error) {
        return Promise.reject({ message: 'Some error occured. ' })
    }
}